import { Card, Button, Affix, Form } from "antd";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useNavigate } from "react-router-dom";
import TaskForm from "./TaskForm";

const AddTask = (props) => {
  const { width } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const discartForm = () => {
    navigate("/tanda/task");
  };
  const addNewProcess = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Add T&A Task"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Discard
              </Button>,
              <Button
                size="small"
                key={2}
                type="primary"
                onClick={() => addNewProcess()}
              >
                Add Task
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <TaskForm form={form} />
    </>
  );
};

export default AddTask;

